import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ViewEncapsulation,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  LayoutService,
  IStepperHorizontal,
  IGrid,
  GridService,
  IOnboarding,
  OnboardingService,
  IToast, ToastService,
  IButtonOptions,
  IDropdown,
  IOnboardingTour
} from 'codex-lib';
import { NewEnvelopeService } from '../envelope/new-envelope/new-envelope.service';
import { NewEnvelopeSteps } from '../enum/new-envelope-steps';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { RoutePages } from '../enum/route-pages';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnalyticsService } from '../modules/google-analytics/service/analytics.service';
import { TrackerData } from '../modules/google-analytics/model/tracker-data.model';
import * as R from 'ramda';
import { InteractService } from '../envelope/services/interact.service';
import { FeatureEnum } from '../enum/feature.enum';
import { SignatureType } from '../enum/signature-type';
import { EnvelopeOnBoardingService } from '../envelope/services/envelope-on-boarding.service';
import { BrowserUtil } from '../util/browser-util';
import { Signatory } from '../envelope/model/signatory';
import { TranslateService } from '@ngx-translate/core';
import { ComponentDragDropService } from '../envelope/services/component-drag-drop.service';
import { WhatasappSettingsService } from '../modules/settings/services/whatsapp-settings.service';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { onboardingNewEnvelopeMobile } from '../envelope/onboarding/onboarding-new-envelope-mobile';
import { onBoardingSignaturePositionTourBase, onBoardingFormFieldsStep, onBoardingSignaturePositionTourOptions } from '../envelope/onboarding/onboarding-signature-position-tour';
import { SentEnvelopeFilter } from '../envelope/model/sent-envelope-filter';
import { SentEnvelopeStatusCounter } from '../envelope/model/sent-envelope-status-counter';
import { SentEnvelopeStatus } from '../enum/sent-envelope-status';
import { SortOrder } from '../enum/sort-order';
import { EnvelopeService } from '../envelope/services/envelope.service';
import { FormCustomField } from '../envelope/model/form-custom-field';

@Component({
  selector: 'app-main-envelope',
  templateUrl: './main-envelope.component.html',
  styleUrls: ['./main-envelope.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MainEnvelopeComponent implements OnInit {
  @Output() closeDialogClick = new EventEmitter();
  @Output() submitDialogClick = new EventEmitter();

  @ViewChild('toolbarCodex') toolbar: TemplateRef<any>;
  @ViewChild('confirmBackModal') private confirmBackModal;
  @ViewChild('rubricsQuestionModal') private rubricsQuestionModal;
  @ViewChild('modalExcludeStamp') private modalExcludeStampModal;
  @ViewChild('modalExcludeRubric') private modalExcludeRubricModal;
  @ViewChild('modalExcludeCustomField') private modalExcludeCustomFieldModal;
  @ViewChild('modalEditCustomField') private modalEditCustomFieldModal;

  onBoardingSignPosition: IOnboardingTour;

  buttonOptions: IButtonOptions[];

  isMobile: boolean = BrowserUtil.isMobile();
  newEnvelopeSteps = NewEnvelopeSteps;
  subjectCurrentStep: Subscription;
  subjectToggleViewer: Subscription;
  onDelete: Subscription;
  onDeleteRubric: Subscription;
  onDeleteCustomField: Subscription;
  onEditCustomField: Subscription;
  steps: IStepperHorizontal[];
  onboarding: IOnboarding[] = [];
  activeModal: NgbActiveModal;
  signatorydropdown: IDropdown;
  dataGid: string;
  fileNameExcludeStamp: string;
  customFieldSelected: FormCustomField;
  listSignatories: [];
  canSendWhatsApp: boolean = false;
  isSendWhatsapp: boolean = false;
  showOnBoardingPosition: boolean = false;
  startEnvelopeFilter: SentEnvelopeFilter;
  statusCounter: SentEnvelopeStatusCounter;

  files: File[];
  customOptions: IGrid = {
    classContent: 'viewer-content',
    classNavbar: 'viewer-navbar',
    classAsideRight: 'viewer-aside-right',
    classAsideLeft: 'viewer-aside-left',
    hideOnColapse: true,
    asideRightWidth: '450px',
    asideLeftWidth: '250px',
  };

  showOnboardingMobile: boolean;
  mobileDesktop: IOnboarding[] = onboardingNewEnvelopeMobile;

  constructor(
    private router: Router,
    public layoutService: LayoutService,
    public newEnvelopeService: NewEnvelopeService,
    private googleAnalyticsService: AnalyticsService,
    private modalService: NgbModal,
    private gridService: GridService,
    private toastService: ToastService,
    private translate: TranslateService,
    private dragDropService: ComponentDragDropService,
    public interactService: InteractService,
    private onboardingService: OnboardingService,
    private envelopeOnBoardingService: EnvelopeOnBoardingService,
    private whatsappSettingsService: WhatasappSettingsService,
    private envelopeService: EnvelopeService) {

    this.layoutService.headerProp.next({ title: 'New envelope' });
    this.subjectCurrentStep = this.newEnvelopeService.currentStepSubject.subscribe((value) => {
      this.steps = value;
      this.files = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Upload);
      let step = this.newEnvelopeService.getCurrentStep();
      if (step === NewEnvelopeSteps.Signatures) {
        this.signatories();
        if (!this.isMobile) {
          this.gridService.toggleAsideLeft(true);
          this.gridService.toggleAsideRight(true);
        } else {
          this.newEnvelopeService.includeSignature = true;
          this.newEnvelopeService.includeSignatureMode();
        }
      } else {
        this.gridService.toggleAsideLeft(false);
        this.gridService.toggleAsideRight(false);
      }
    });
    this.subjectToggleViewer = this.layoutService.clickButtonGoBackEventProp.subscribe((x) =>
      this.showConfirmWindow()
    );
  }

  ngOnInit() {
    this.googleAnalyticsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
        'Signer_NovEnv_Criar'
      )
    );

    this.checkFirstEnvelope();
    this.whatsappSettingsService.getSendMessageWhatsapp().subscribe((response) => {
      this.canSendWhatsApp = response;

      if (this.canSendWhatsApp) {
        this.whatsappSettingsService.getSendingByWhatsapp().subscribe((response) => {
          this.isSendWhatsapp = response;
        });
      }
    });

    this.toggleViewerGrid();
    this.onboardingService.registerOnboarding('onboardingRubric');
    this.onboardingService.registerOnboarding('onboardingRubricRemember');
    this.onboardingService.registerOnboarding('mobileDesktopView');
    this.onboardingService.registerOnboarding('onboardingSignPosition');

    this.onDelete = this.dragDropService.onDelete.subscribe((event) => {
      this.dataGid = event[0];
      this.fileNameExcludeStamp = event[1];
      this.activeModal = this.modalService.open(this.modalExcludeStampModal);
    })

    this.onDeleteRubric = this.dragDropService.onDeleteRubric.subscribe((event) => {
      this.dataGid = event[0];
      this.fileNameExcludeStamp = event[1];
      this.activeModal = this.modalService.open(this.modalExcludeRubricModal);
    });

    this.onDeleteCustomField = this.dragDropService.onDeleteCustomField.subscribe((event) => {
      this.dataGid = event[0];
      this.fileNameExcludeStamp = event[1];
      this.activeModal = this.modalService.open(this.modalExcludeCustomFieldModal);
    });

    this.onEditCustomField = this.dragDropService.onEditCustomField.subscribe((customField) => {
      this.customFieldSelected = Object.assign(new FormCustomField(), customField);
      this.activeModal = this.modalService.open(this.modalEditCustomFieldModal, {
        windowClass: 'custom-field-edit-modal',
      });
    });
  }

  ngAfterViewInit(): void {
    if (this.isMobile) {
      setTimeout(() => {
        this.onboardingService.openOnboarding(true, 'mobileDesktopView');
      });
    }
  }

  checkFirstEnvelope() {
    this.startEnvelopeFilter = new SentEnvelopeFilter();
    this.startEnvelopeFilter.status = SentEnvelopeStatus.pending;
    this.startEnvelopeFilter.skip = 0;
    this.startEnvelopeFilter.take = 25;
    this.startEnvelopeFilter.sortOrder = SortOrder.Ascending;

    this.envelopeService
      .getSentEnvelopeStatusCounter(this.startEnvelopeFilter)
      .subscribe({
        next: this.fillImboxStatusCounterData,
        error: (err) => {
          console.error('error', err);
          this.newEnvelopeService.needCreateFirstEnvelope = false;
        }
      });
  }

  fillImboxStatusCounterData = (data: SentEnvelopeStatusCounter) => {
    this.statusCounter = Object.assign({}, data);
    this.newEnvelopeService.needCreateFirstEnvelope = this.totalEnvelopeCount(this.statusCounter) === 0;
  };

  totalEnvelopeCount(x) {
    let count = 0;
    count += x.completed;
    count += x.deleted;
    count += x.expired;
    count += x.onApproval;
    count += x.pending;
    count += x.reproved;
    count += x.rejected;
    count += x.toFill;
    return count;
  }

  excludeSingleStamp() {
    this.activeModal.close();
    this.newEnvelopeService.excludeSingleStamp(this.dataGid);
  }

  excludeSingleRubric() {
    this.activeModal.close();
    this.newEnvelopeService.excludeSingleRubric(this.dataGid);
  }

  excludeSingleCustomField() {
    this.activeModal.close();
    this.newEnvelopeService.excludeSingleCustomField(this.dataGid);
  }

  closeEditCustomFieldModal() {
    this.activeModal.dismiss();
    this.customFieldSelected = null;
  }

  saveCustomField(customField: FormCustomField) {
    if (!customField) {
      return;
    }

    const customFieldToSave = Object.assign(new FormCustomField(), customField);
    const parsedFontSize = Number(customFieldToSave.fontSize);
    customFieldToSave.fontSize = Number.isFinite(parsedFontSize)
      ? Math.max(8, Math.min(18, parsedFontSize))
      : 12;
    customFieldToSave.displayName = (customFieldToSave.displayName || '').trim();

    this.dragDropService.updateCustomField(customFieldToSave);
    this.activeModal.close();
    this.customFieldSelected = null;
  }

  openExcludeCustomFieldModal() {
    if (!this.customFieldSelected) {
      return;
    }

    this.dataGid = this.customFieldSelected.gId;
    this.fileNameExcludeStamp = this.customFieldSelected.fileName;
    this.activeModal.close();
    this.customFieldSelected = null;
    this.activeModal = this.modalService.open(this.modalExcludeCustomFieldModal);
  }

  toggleViewerGrid() {
    this.gridService.toggleGrid();
  }

  asideRight() {
    this.gridService.toggleAsideRight();
  }

  asideLeft() {
    this.gridService.toggleAsideLeft();
  }

  ngOnDestroy(): void {
    this.subjectCurrentStep?.unsubscribe();
    this.subjectToggleViewer?.unsubscribe();
    this.onDeleteRubric?.unsubscribe();
    this.onDelete?.unsubscribe();
    this.onDeleteCustomField?.unsubscribe();
    this.onEditCustomField?.unsubscribe();
    this.newEnvelopeService.initModelData();
    this.toggleViewerGrid();
  }

  showConfirmWindow() {
    this.gridService.toggleAsideRight(false);
    this.activeModal = this.modalService.open(this.confirmBackModal);
  }


  stepNext() {
    const step = this.newEnvelopeService.getCurrentStep();

    if (step != NewEnvelopeSteps.Signatory) {
      var isValidNextStep = this.newEnvelopeService.stepNext();

      if (isValidNextStep) {
        switch (step) {
          case NewEnvelopeSteps.Upload:
            this.googleAnalyticsService.sendEvent(
              new TrackerData(
                AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
                'Signer_NovEnv_UploadConcuÃ­do'
              )
            );
            break;
          case NewEnvelopeSteps.Settings:
            this.googleAnalyticsService.sendEvent(
              new TrackerData(
                AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
                'Signer_NovEnv_ConfigurarConcluÃ­do'
              )
            );
            break;
          case NewEnvelopeSteps.Signatures:
            this.googleAnalyticsService.sendEvent(
              new TrackerData(
                AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
                'Signer_NovEnv_AssinaturasConcluido'
              )
            );
            break;
        }
      }
      return;
    }

    if (!this.newEnvelopeService.isValidSignatoriesStep(step))
      return;

    this.googleAnalyticsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
        'Signer_NovEnv_SignatariosConcluido'
      )
    );

    const signatories = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory)['elements'] as Array<Signatory>;
    var hasManySignatories = signatories.filter(x =>
      x.signatureType.id === SignatureType.ELETRONIC ||
      x.signatureType.id === SignatureType.INPERSON ||
      x.signatureType.id === SignatureType.SELFIE).length > 14;
    var hasEletronicSignatoriesOnly = !signatories.some(x => x.signatureType.id === SignatureType.BOTH || x.signatureType.id === SignatureType.DIGITAL);

    if (hasManySignatories) {
      this.showWarning('envelope.main-envelope.lockRubric');
      this.disableRubrics();
    } else if (hasEletronicSignatoriesOnly) {
      this.interactService.withRubrics = true;
    } else {
      if (!this.isMobile)
        this.showWarning('businessError.rubricWarning');

      this.disableRubrics();
    }

    this.newEnvelopeService.stepNext();
  }

  private disableRubrics(): void {
    this.interactService.withRubrics = false;
    this.interactService.includeRubrics = false;
    this.newEnvelopeService.excludeAllRubric();
  }

  showWarning(msg: string) {
    const toast: IToast = {
      text: this.translate.instant(msg),
      autoHide: true,
      type: 'warning'
    };
    this.toastService.createNewToast(toast);
  }

  modalClose() {
    this.activeModal.dismiss();
  };

  stepBack() {
    this.gridService.toggleAsideRight(false);
    this.layoutService.toggleLoading(true);
    this.newEnvelopeService.stepBack();
    this.layoutService.toggleLoading(false);

  }

  signatories() {
    const stepModel = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory);
    this.listSignatories = stepModel?.['elements'] ?? [];
  }

  addIdButtonsNext(): string {
    const step = this.newEnvelopeService.getCurrentStep();
    switch (step) {
      case NewEnvelopeSteps.Upload: return "id.sign.newenvelope.upload.next";
      case NewEnvelopeSteps.Settings: return "id.sign.newenvelope.settings.next";
      case NewEnvelopeSteps.Signatory: return "id.sign.newenvelope.signatory.next";
      case NewEnvelopeSteps.Signatures: return "id.sign.newenvelope.signatures.next";
      case NewEnvelopeSteps.Review: return "id.sign.newenvelope.review.send";
    }
  }

  addIdButtonsBack(): string {
    const step = this.newEnvelopeService.getCurrentStep();
    switch (step) {
      case NewEnvelopeSteps.Upload: return "id.sign.newenvelope.upload.back";
      case NewEnvelopeSteps.Settings: return "id.sign.newenvelope.settings.back";
      case NewEnvelopeSteps.Signatory: return "id.sign.newenvelope.signatory.back";
      case NewEnvelopeSteps.Signatures: return "id.sign.newenvelope.signatures.back";
      case NewEnvelopeSteps.Review: return "id.sign.newenvelope.review.back";
    }
  }

  isValidStepInfo() {
    return this.newEnvelopeService.isValidModelData();
  }

  confirmModalClose() {
    this.activeModal.dismiss();
  }

  async confirmModalYesClick() {
    this.newEnvelopeService.cancelEnvelope();
    this.router.navigate([RoutePages.Root]);
    this.activeModal.dismiss();
  }

  getMultipleFilesAndSelectFile() {
    if (this.files) {
      return R.pathOr(0, ['length'], this.files) > 1;
    }
  }

  openOnBoardingOrModalRubric() {
    if (!this.isMobile) {
      this.envelopeOnBoardingService.verifyViewed(FeatureEnum.positionRubric).subscribe(
        (dataRubric) => {
          if (!dataRubric) {
            this.onboardingService.openOnboarding(true, 'onboardingRubric');
          } else {
            this.openModalRubrics();
          }
        });
    }
  }

  markAsViewed(feature: FeatureEnum) {
    this.onboardingService.openOnboarding(false, 'onboardingRubric');
    this.layoutService.toggleLoading(true);
    this.envelopeOnBoardingService.maskAsViewed(feature).subscribe(
      (x) => {
        this.openModalRubrics();
        this.layoutService.toggleLoading(false);
      },
      (error: any) => {
        this.openModalRubrics();
        this.layoutService.toggleLoading(false);
      }
    );
  }

  openModalRubrics() {
    setTimeout(() => {
      this.activeModal = this.modalService.open(this.rubricsQuestionModal);
    }, 0);
  }

  onTutorialClick() {
    if (!this.isMobile) {
      this.buildOnBoardingTour();
      this.showOnBoardingPosition = true;
    }
  }

  buildOnBoardingTour() {
    const tourOptions = { ...onBoardingSignaturePositionTourOptions };
    const steps = [...onBoardingSignaturePositionTourBase.steps];
    if (this.newEnvelopeService.includeComponent) {
      steps.push(onBoardingFormFieldsStep);
    }
    tourOptions['steps'] = steps;
    this.onBoardingSignPosition = tourOptions as IOnboardingTour;
  }

  handleClosePositionTour(event) {
    if (!event)
      this.onboardingService.openOnboarding(true, 'onboardingSignPosition');

    this.showOnBoardingPosition = false;
  }

  primaryBtnClickedMobile() {
    this.modalService.dismissAll();
    this.showOnboardingMobile = false;

    this.googleAnalyticsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
        'Signer_NovEnv_UploadModalMobile'
      )
    );
  }
}
